<template lang="pug">
  .hardware-simulator
    .header
      img(src='/static/hwsim/logo.svg')
    .hw-main-section
      h3.hw-title.align-self-middle Vehicle Status
      .hw-main-row.align-center.align-middle
        .hw-plate
          input(type='text', v-model="serial")
        .hw-car(:class="{running: ignition_status}")
          img(src='/static/hwsim/model3.png')
          label.hw-ignition.pulse(
          :class="{disabled: !serial || serial.length < 6, active: ignition_status}"
          @click.prevent="toggleIgnition()"
          )
            input(type="checkbox" v-model="ignition_status" )
          label.hw-doors.pulse(
          :class="{disabled: !serial || serial.length < 6, active: door_status}"
          @click.prevent="toggleDoors()"
          )
            input(type="checkbox" v-model="door_status" )
        .hw-on-board(v-if="reservation && reservation.reservation")
          p.hw-label.active(v-if="reservation.reservation.status === 'STARTED'") client on board
          p.hw-label(v-else) no client on board
      .hw-main-row.align-center.align-middle.hw-data(v-if="reservation && reservation.reservation")
        .hw-column
          p reservation number
          p.hw-res-number {{reservation.reservation.number}}
        .hw-column
          p.hw-date {{format(reservation.reservation.start).date}}
          p.hw-time {{format(reservation.reservation.start).time}}
        .hw-column
          p.hw-date {{format(reservation.reservation.end).date}}
          p.hw-time {{format(reservation.reservation.end).time}}
        .hw-column
          p.hw-label(
          :class="{active: reservation.reservation.status === 'STARTED'}"
          ) {{reservation.reservation.status}}
          p.hw-distance {{reservation.reservation.distance}}km driven
          p.hw-trips {{reservation.reservation.trips_count}} trips
    .hw-controls
      h4.hw-title Trip run simulation
      p you need to open door and switch on engine
      .hw-row-center
        .hw-column
          label
            input(type='number', v-model="trip_distance", min='0', max='999')
            p km
        .hw-column.hw-center-column
          button.hw-wheel-button(@click="sendTrip" :class="{loading, disabled: !readyToSend}")
          label
            p.align-self-middle send
        .hw-column
          label
            input(type='number', v-model="fuel_level", min='0', max='100')
            p fuel level
</template>

<script>
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import moment from 'moment'

  export default {
    name: "HwSim",
    mounted() {
      this.updateReservation()
      this.poolStart()
    },
    data() {
      return {
        serial: 'MAN002',
        fuel_level: 100,

        ignition: null,
        trip_start: null,
        trip_end: null,
        trip_distance: 100,

        ignition_status: false,
        door_status: false,

        loading: false,
        running: false,
        clientOnBoard: false,

        reservation: null,
        pooler: null
      }
    },
    methods: {
      toggleDoors() {
        if (this.serial && this.serial.length > 5) {
          const stat = !this.door_status ? "UNLOCKED" : "LOCKED"
          KeplerBackofficeSdk.hooks.manual({
            serial: this.serial,
            ignition: this.ignition_status ? "RUNNING" : "NOT_RUNNING",
            fuel_level: this.fuel_level,
            door_status: stat,
          }, () => {
            this.door_status = !this.door_status
          })
        }
      },
      toggleIgnition() {
        if (this.serial && this.serial.length > 5) {
          const stat = !this.ignition_status ? "RUNNING" : "NOT_RUNNING"
          KeplerBackofficeSdk.hooks.manual({
            serial: this.serial,
            door_status: this.door_status ? "UNLOCKED" : "LOCKED",
            fuel_level: this.fuel_level,
            ignition: stat
          }, (data) => {
            this.ignition_status = !this.ignition_status
          })
        }
      },
      sendTrip() {
        if (this.readyToSend) {
          this.loading = true
          var body = {
            serial: this.serial,
            fuel_level: this.fuel_level,
            door_status: this.door_status,
            ignition: this.ignition,
            action: "NEW_TRIP",
            action_data: {
              trip_start: this.trip_start,
              trip_end: this.trip_end,
              trip_distance: this.trip_distance,
            },
          }
          KeplerBackofficeSdk.hooks.manual(body, () => {
            this.loading = false
          })
        }
      },
      updateReservation() {
        KeplerBackofficeSdk.hooks.vehicleStatus(this.serial, (data) => {
          this.reservation = data
          this.door_status = data.vehicle_status.doors === 'UNLOCKED'
          this.ignition_status = data.vehicle_status.engine === 'RUNNING'
        })
      },
      poolStart() {
        this.pooler = setTimeout(() => {
          this.updateReservation()
          this.poolStart()
        }, 5000)
      },
      format(date) {
        const m = moment(date)
        return {
          date: m.format('DD MMMM YYYY'),
          time: m.format('hh:mm')
        }
      }
    },
    computed: {
      readyToSend() {
        return this.serial && this.serial.length > 5 && this.fuel_level && this.trip_distance
      }
    }
  }
</script>

<style lang="sass" rel="stylesheet/sass">
  @import url('https://fonts.googleapis.com/css?family=Montserrat:300,400,500,600,700')
  $green: #45E8C5
  $grey: #8E99A8
  $grey_light: #dadada
  $offwhite: #fafafa

  @keyframes letsroll
    0%
      transform: perspective(20em) rotateX(70deg) translateY(1em) scale(3, 1) translateX(-100vw)
    50%
      transform: perspective(20em) rotateX(70deg) translateY(1em) scale(1, 1) translateX(0)
    100%
      transform: perspective(20em) rotateX(70deg) translateY(1em) scale(3, 1) translateX(100vw)

  @keyframes rotate
    0%
      transform: rotate(0deg)
    100%
      transform: rotate(360deg)

  .hardware-simulator
    font-family: 'Montserrat', 'Roboto', sans-serif
    font-size: 1rem
    color: $grey
    background-color: #fff
    height: 100vh
    width: 100vw
    max-width: 1024px
    /*display: flex*/
    flex-flow: column nowrap
    overflow: hidden

    @media screen and (device-width: 768px) and (device-height: 1024px) and (orientation: portrait)
      // iPad with portrait orientation.
      height: 1024px
      width: 100%
    @media screen and (device-width: 768px) and (device-height: 1024px) and (orientation: landscape)
      // iPad with landscape orientation.
      height: 768px
      width: 100%

    .header
      height: 6.25rem
      width: 100%
      display: flex
      align-items: center
      justify-content: center
      background: linear-gradient(180deg, rgba($green, 0.3) 0%, rgba($green, 0.1) 50%, transparent 100%)
    .hw-main-section
      flex-grow: 1
      display: flex
      flex-flow: column wrap
      align-items: center
      justify-content: center
      .hw-main-row
        display: flex
        flex-flow: row nowrap
        .hw-plate
          input
            font-size: 1.25em
            padding: .5rem 1rem
            width: 8.5rem
            text-align: center
            font-weight: 400
            color: $grey
            background: $offwhite
            border: 1px solid $grey_light
            font-family: montserrat, sans-serif
            outline: none
        .hw-car
          width: 100%
          max-width: 60%
          position: relative
          &:before
            content: ''
            position: absolute
            width: 100%
            height: 50%
            bottom: 0
            background: $green
            z-index: 0
            transform: perspective(20em) rotateX(70deg) translate(0, 1em) scale(1, 1)
          // shadow
            background-image: radial-gradient($green 50%, transparent 75%)
            transform: perspective(20em) rotateX(75deg) translateY(1em) scale(1, 1)
          &.running:before
            animation: letsroll 1.5s infinite
          img
            position: relative
            z-index: 1

          label.hw-ignition
            top: 25%
            left: 20%
          label.hw-doors
            bottom: 50%
            left: 50%
        .hw-on-board
        &.hw-data
          .hw-column:not(:last-child)
            border-right: 1px solid $grey_light
          p
            margin-bottom: 0
            line-height: 1.618
            &.hw-res-number
              font-size: 1.5em
              font-weight: 700
            &.hw-date
              font-size: 1.5em
              font-weight: 300
            &.hw-time
              font-size: 1.5em
              font-weight: 600
            &.hw-distance
              margin-top: 0.618em
            &.hw-trips

    .hw-label
      width: 100%
      padding: 0.5em 2em
      font-size: .75em
      background-color: $grey
      border-radius: 2em
      color: white
      text-transform: uppercase
      &.active
        background-color: $green
    .hw-controls
      display: flex
      flex-flow: column nowrap
      align-items: center
      margin: auto 0 0 0
      padding-bottom: 2em
    .hw-title
      font-size: 1em
      text-transform: uppercase

    .hw-row-center
      display: flex
      flex-flow: row nowrap
      justify-content: center
    .hw-column
      display: flex
      flex-flow: column nowrap
      align-items: center
      text-align: center
      padding: 1em 2em
      &.hw-center-column
        border: 0 solid $grey_light
        border-right-width: 1px
        border-left-width: 1px
        padding: 0 2em 0
      label
        color: $grey
        text-transform: none
        font-weight: normal
        font-size: 1rem
        p
          margin: 0
          line-height: 2rem
      input
        font-size: 2em
        margin: 0
        padding: .5rem 1rem
        width: 8.5rem
        height: 2em
        text-align: center
        font-weight: 400
        color: $grey
        background: $offwhite
        border: 1px solid $grey_light
        font-family: montserrat, sans-serif
        outline: none
    button.hw-wheel-button
      border-radius: 50%
      padding: 4em
      outline: none
      transition: .2s transform
      background: $green url(/static/hwsim/volante.svg) no-repeat center
      &.disabled
        background-color: $grey
      &.loading
        animation: rotate 1s 1s 1
      img
        width: 100%
    .pulse
      position: absolute
      background-size: cover
      background: url("/static/hwsim/pulse.svg") center
      -webkit-mask-image: url("/static/hwsim/pulse.svg")
      -webkit-mask-size: contain
      -webkit-mask-position: center
      height: 4em
      width: 4em
      z-index: 2
      border-radius: 100%
      transition: .5s all
      &.active
        background: $green
      &.disabled
        background: transparent
      & input[type='checkbox']
        display: none

</style>



// WEBPACK FOOTER //
// HwSim.vue?2d7e7827